import { filterTestSetsByModule } from "../../utils";
import { Module } from "../../../../../constants";
import { buildJourneyPhases } from "./utils";
import { UseSolutionJourneyArgs } from "./types";

export function useSolutionJourney({
  testSets,
  currentTestId,
}: UseSolutionJourneyArgs) {
  const solutionTestSets = filterTestSetsByModule(
    testSets,
    Module.Solution,
    currentTestId
  );

  if (solutionTestSets.length) {
    return buildJourneyPhases(solutionTestSets[0]);
  }
  return [];
}
